export var isNumber = function (value) {
    return typeof value === 'number' && !isNaN(value);
};
